import React, { createContext, useState, useContext, useMemo, ReactNode } from 'react';
import { SpheraSpinner } from '@sphera-cloud/component-ui-reactjs';
import { createPortal } from 'react-dom';

interface SpinnerContextProps {
  showSpinner?: boolean;
  setShowSpinner: React.Dispatch<React.SetStateAction<boolean>>;
}

interface SpinnerProviderProps {
  children: ReactNode;
}

const SpinnerContext = createContext<SpinnerContextProps>({ setShowSpinner: () => { } });

const SpinnerProvider: React.FC<SpinnerProviderProps> = ({ children }) => {
  const [showSpinner, setShowSpinner] = useState(false);

  const renderLoader = () => (
    <div className="global-spinner" data-testid="global-spinner">
      <SpheraSpinner version={2} color="dark-1" size="large" />
    </div>
  );

  const contextValue = useMemo(
    () => ({ showSpinner, setShowSpinner }),
    [showSpinner, setShowSpinner],
  );

  return (
    <SpinnerContext.Provider value={contextValue}>
      {showSpinner && createPortal(renderLoader(), document.body)}
      {children}
    </SpinnerContext.Provider>
  );
};

export default SpinnerProvider;

export const useSpinnerContext = () => useContext(SpinnerContext);
